import { Chip } from "@mui/material";
import { LISTING_PLATFORM_OPTIONS, platformChipSx } from "../listingPlatform";

// Sized like the grid's SingleSelectCell chips. An unknown or missing
// platform renders nothing rather than guessing.
export function PlatformChipCell({ platform }: { platform?: string | null }) {
  const option = LISTING_PLATFORM_OPTIONS.find((o) => o.value === platform);
  if (!option) return null;

  return (
    <Chip label={option.label} size="small" sx={platformChipSx(option.value)} />
  );
}
